module.exports = __webpack_public_path__ + "static/img/unit2.30cf5c9.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/unit2.png
// module id = +oP5
// module chunks = 1